import { createDecorator } from "vue-class-component";
import { SYM_ROOT_CONTAINER } from "./InversifyPlugin";
/**
 * Injects a dependency into the decorated property.
 * @param type The identifier of the dependency. Usually a class' constructor or a symbol.
 */
export function InjectService(type) {
    return createDecorator((options, key) => {
        options.mixins = options.mixins ?? [];
        options.mixins.push({
            beforeCreate() {
                const container = this[SYM_ROOT_CONTAINER];
                this[key] = container.get(type);
            },
        });
    });
}
//# sourceMappingURL=InjectService.js.map